import styles from "./style.module.css";
import classnames from 'classnames';

export function Button(props) {
    return (
        <button {...props} type={props.type || "button"} className={classnames(styles.button, props.className, styles[props.color], styles[props.size])}>{props.children}</button>
    )
}